import React, { useEffect, useRef, useState } from "react";

const DURATION_MS = 2200; // total loader duration

const LuxuryLoader: React.FC = () => {
    const [percentage, setPercentage] = useState(0);
    const [visible, setVisible] = useState(true);
    const [fadingOut, setFadingOut] = useState(false);
    const ringRef = useRef<SVGCircleElement>(null);

    // Circumference of a circle with r=54: 2π×54 ≈ 339.3
    const CIRCUMFERENCE = 2 * Math.PI * 54;

    useEffect(() => {
        const startTime = Date.now();

        const tick = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / DURATION_MS, 1);
            const pct = Math.round(progress * 100);
            setPercentage(pct);

            // Update SVG ring
            if (ringRef.current) {
                const offset = CIRCUMFERENCE * (1 - progress);
                ringRef.current.style.strokeDashoffset = String(offset);
            }

            if (progress < 1) {
                requestAnimationFrame(tick);
            } else {
                // Start fade-out
                setFadingOut(true);
                setTimeout(() => {
                    setVisible(false);
                }, 850);
            }
        };

        requestAnimationFrame(tick);
    }, [CIRCUMFERENCE]);

    if (!visible) return null;

    return (
        <div
            className={`luxury-loader${fadingOut ? " fade-out" : ""}`}
            style={{
                opacity: fadingOut ? 0 : 1,
                transition: "opacity 0.8s ease",
            }}
        >
            {/* Brand name */}
            <div className="loader-brand">Eleego</div>
            <div className="loader-tagline">Premier Chauffeur &amp; Limousine</div>
            <div className="loader-gold-line" />

            {/* Globe + ring wrapper */}
            <div className="loader-globe-wrapper">
                {/* Circular progress ring */}
                <svg
                    className="loader-ring"
                    viewBox="0 0 120 120"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Background track */}
                    <circle cx="60" cy="60" r="54" />
                    {/* Progress arc */}
                    <circle
                        ref={ringRef}
                        className="ring-progress"
                        cx="60"
                        cy="60"
                        r="54"
                        style={{
                            strokeDasharray: CIRCUMFERENCE,
                            strokeDashoffset: CIRCUMFERENCE,
                        }}
                    />
                </svg>

                {/* Rotating Globe Icon */}
                <div className="loader-globe">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <circle cx="12" cy="12" r="10" />
                        <line x1="2" y1="12" x2="22" y2="12" />
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                    </svg>
                </div>

                {/* Percentage counter */}
                <div className="loader-percentage">{percentage}%</div>
            </div>
        </div>
    );
};

export default LuxuryLoader;
